import { NamirasoftMap } from "namirasoft-site-map";
import { ProductUUID } from "namirasoft-api-product";
import { TicketRow, TicketInputRow, CategoryRow } from "namirasoft-support";
import { IStorageLocal } from "namirasoft-core";
import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { BaseColumnFormatter, DateTimeFormatter, IDFormatter, StringFormatter, StringFormatterSizeType, EnumFormatter, ForeColorFormatter } from "namirasoft-site-react";
import { SupportProps } from "./SupportProps";
import { SupportRoutes } from "./SupportRoutes";
import { SupportMenus } from "./SupportMenus";

export class SupportEntities
{
    static ticket(props: NSARouterMakerResult & SupportProps, onReload?: () => void): IEntityInfo<TicketRow, TicketInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_SUPPORT,
            name: "ticket",
            tables: [{ table: namirasoft.support.tables.ticket, required: true }],
            client: {
                getColumns()
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.resource_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.category_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.title, new StringFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.priority, new ForeColorFormatter(new EnumFormatter(), {
                            Low: "gray",
                            Medium: "orange",
                            High: "tomato",
                            Urgent: "red"
                        })),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.status, new ForeColorFormatter(new EnumFormatter(), {
                            Open: "tomato",
                            InProgress: "orange",
                            Resolved: "green",
                            Closed: "gray"
                        })),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.assignee, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.ticket.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => SupportRoutes.TicketList,
                getNewURL: () => SupportRoutes.TicketNew,
                getCopyURL: (id: string) => SupportRoutes.TicketCopy(id),
                getViewURL: (id: string) => SupportRoutes.TicketView(id),
                getEditURL: null,
                getMenus: (getIDs, getRows) => ({ "Ticket Resolve": [SupportMenus.TicketResolve(getIDs, getRows, props, onReload)] })
            },
            server: {
                value_list: props.servers.support.value.List,
                get: props.servers.support.ticket.Get,
                list: props.servers.support.ticket.List,
                create: props.servers.support.ticket.Create,
                update: null,
                delete: null
            }
        };
    }

    static category(props: NSARouterMakerResult & SupportProps): IEntityInfo<CategoryRow, CategoryRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_SUPPORT,
            name: "cetegory",
            tables: [{ table: namirasoft.support.tables.category, required: true }],
            client: {
                getColumns()
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.category.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.category.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.category.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.category.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.support.tables.category.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => SupportRoutes.CategoryList,
                getViewURL: (id) => SupportRoutes.CategoryView(id),
                getCopyURL: null,
                getEditURL: null,
                getNewURL: null,
            },
            server: {
                value_list: props.servers.support.value.List,
                list: props.servers.support.category.List,
                get: props.servers.support.category.Get,
                create: null,
                update: null,
                delete: null
            }
        };
    }
}